import type {TextareaProps} from '@chakra-ui/react';
import {Textarea} from '@chakra-ui/react';
import type {FieldPath, FieldValues} from 'react-hook-form';
import {useController} from 'react-hook-form';

export type FieldTextareaProps<TName> = Omit<TextareaProps, 'name'> & {
  name: TName;
};

export const FieldTextarea = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  ...rest
}: FieldTextareaProps<TName>) => {
  const {field} = useController({name});

  return <Textarea {...field} value={field.value || ``} {...rest} />;
};
